import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { Tag } from '../../../../models/tag';

interface StatusesDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (statusIds: number[]) => void;
  tags: Tag[];
  selectedStatuses?: number[];
}

export const StatusesDialog: React.FC<StatusesDialogProps> = ({
  isOpen,
  onDismiss,
  onSave,
  tags,
  selectedStatuses = [],
}) => {
  const [selected, setSelected] = useState<number[]>([]);

  useEffect(() => {
    setSelected(selectedStatuses || []);
  }, [selectedStatuses]);

  const handleSave = () => {
    onSave(selected);
  };

  const handleSelectionChange = (tagId: number, isChecked: boolean) => {
    if (isChecked) {
      setSelected([...selected, tagId]);
    } else {
      setSelected(selected.filter(id => id !== tagId));
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onDismiss()}>
      <DialogSurface className="min-w-[500px]">
        <DialogBody>
          <div className="flex justify-between items-center mb-4">
            <DialogTitle>Statusetiketter</DialogTitle>
            <Button
              appearance="subtle"
              icon={<DismissRegular />}
              onClick={onDismiss}
              aria-label="Close"
            />
          </div>
          <DialogContent>
            <div className="space-y-2 min-h-[300px]">
              <h5 className="text-base font-medium mb-3">Välj Statusetiketter</h5>
              {tags.map((tag) => (
                <label key={tag.tagID} className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selected.includes(tag.tagID)}
                    onChange={(e) => handleSelectionChange(tag.tagID, e.target.checked)}
                    className="w-4 h-4"
                  />
                  <span>{tag.tagName}</span>
                </label>
              ))}
            </div>
          </DialogContent>
          <DialogActions className="flex justify-end gap-2 mt-4">
            <Button appearance="primary" onClick={handleSave}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
